// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// toast.configure();

// const Toast = {
//   success: (message) => {
//     toast.success(message, { position: toast.POSITION.TOP_RIGHT });
//   },
//   error: (message) => {
//     toast.error(message, { position: toast.POSITION.TOP_RIGHT });
//   },
// };

// export default Toast;

import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toast = {
  success: (message) => toast.success(message),
  error: (message) => toast.error(message),
  info: (message) => toast.info(message),
};

const ToastWrapper = () => (
  <ToastContainer
    position='top-right'
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
);

export { Toast, ToastWrapper };

// import React from 'react';
// import { ToastWrapper } from './components/common/Toast';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// function App() {
//   return (
//     <Router>
//       {/* Other components */}
//       <ToastWrapper />
//     </Router>
//   );
// }

// export default App;

// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// toast.configure();

// const Toast = {
//   success: (message) => toast.success(message, { position: toast.POSITION.TOP_RIGHT }),
//   error: (message) => toast.error(message, { position: toast.POSITION.TOP_RIGHT }),
// };

// export default Toast;

// import { ToastContainer } from 'react-toastify';

// function App() {
//   return (
//     <div>
//       <Routes>
//         {/* Your Routes */}
//       </Routes>
//       <ToastContainer />
//     </div>
//   );
// }
